/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Cross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Cross"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#94B200"
      d="M15.334 2.833A.833.833 0 0 0 14.5 2h-5a.833.833 0 0 0-.833.833v5c0 .46-.373.834-.833.834h-5A.833.833 0 0 0 2 9.5v5c0 .46.373.834.833.834h5c.46 0 .834.373.834.833v5c0 .46.373.833.833.833h5c.46 0 .834-.373.834-.833v-5c0-.46.373-.834.833-.834h5c.46 0 .833-.373.833-.833v-5a.833.833 0 0 0-.833-.833h-5a.833.833 0 0 1-.834-.833z"
      className="SVG"
    />
  </svg>
);

export const CrossIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'cross-icon'}
      icon={Cross}
      {...props}
      size={size}
    />
  );
};
